module.exports = __webpack_public_path__ + "img/test-image.ddba514e.png";